import React from 'react';

function VerifyExpiredPage() {
    return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center p-6">
            <div className="max-w-md w-full bg-slate-900 border border-slate-800 rounded-2xl p-8 shadow-2xl text-center">
                <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                    <span className="text-3xl">⏰</span>
                </div>

                <h1 className="text-3xl font-bold text-white mb-4">Link Expired</h1>
                <p className="text-slate-400 mb-8 leading-relaxed text-lg">
                    This magic link has expired or has already been used. Please return to the homepage and enter your details again to get a fresh link.
                </p>

                <div className="space-y-4">
                    <button
                        onClick={() => window.location.href = '/'}
                        className="w-full py-4 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-500 transition-all shadow-lg shadow-indigo-500/20 text-lg"
                    >
                        Return to Homepage
                    </button>
                </div>
            </div>
        </div>
    );
}

export default VerifyExpiredPage;
